import ColorThief, { Color } from 'colorthief';
const cssId = 'gradient-style';

export default {
    callable: (element: HTMLElement) => {
        const gradientElements = element.querySelectorAll(
            'img[data-distribution-gradient]'
        );
        [].forEach.call(gradientElements, (img: HTMLImageElement) => {
            if (img.complete) {
                applyGradient(img, element);
            } else {
                img.onload = () => {
                    if (img.complete) {
                        applyGradient(img, element);
                    } else {
                        addStyle(element.id, img.currentSrc, light, dark);
                    }
                };
                img.onerror = () => {
                    addStyle(element.id, img.currentSrc, light, dark);
                };
            }
        });
    },
};

function applyGradient(img: HTMLImageElement, element: HTMLElement) {
    const colorThief = new ColorThief();
    const color = colorThief.getColor(img);
    if (color) {
        const palette = colorThief.getPalette(img, 5, 10);

        const { start, stop } = colorPicker(color, palette);
        addStyle(element.id, img.currentSrc, start, stop);
    }
}

const black: Color = [0, 0, 0];
const white: Color = [255, 255, 255];
const dark: Color = [0, 99, 252];
const light: Color = [6, 191, 252];

function addStyle(id: string, src: string, start: Color, stop: Color) {
    const backgroundColor = `linear-gradient(-160deg, rgba(${start[0]},${start[1]},${start[2]}, 0.5), rgba(${stop[0]},${stop[1]},${stop[2]}, 0.5))`;
    const style = document.createElement('style');
    style.setAttribute('id', cssId);
    document.head.appendChild(style);
    if (style.sheet) {
        const styleSheet = style.sheet as CSSStyleSheet;
        styleSheet.insertRule(`
                            .gradient-image--${id} {
                                background-image: ${backgroundColor};
                            }`);
        styleSheet.insertRule(`
                            .gradient-image-logo--${id} {
                                background-image: url(${src}),
                                                  url(${src}),
                                                  url(${src}),
                                                  url(${src}),
                                                  url(${src}),
                                                  url(${src}),
                                                  url(${src});
                            }`);
    }
}

function toBlack(color: Color) {
    const distance = colorDistance(black, color);
    return distance > 100;
}

function colorPicker(dominant: Color, palette: Color[]) {
    const sorted = palette.sort(bySaturation);
    const filtered = sorted.filter(toBlack);
    if (filtered.length > 1) {
        const stop = sorted[0];
        const start = sorted.find((c) => colorDistance(stop, c) > 190) || white;
        return { start, stop };
    }
    return { start: white, stop: dominant };
}

function colorDistance(color1: Color, color2: Color) {
    const x =
        Math.pow(color1[0] - color2[0], 2) +
        Math.pow(color1[1] - color2[1], 2) +
        Math.pow(color1[2] - color2[2], 2);
    return Math.sqrt(x);
}

function saturation(color: Color) {
    let [r, g, b] = color;

    r /= 255;
    g /= 255;
    b /= 255;

    let cmin = Math.min(r, g, b),
        cmax = Math.max(r, g, b),
        delta = cmax - cmin,
        s = 0,
        l = 0;

    l = (cmax + cmin) / 2;

    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));

    s = +(s * 100).toFixed(1);

    return s;
}

function bySaturation(colorA: Color, colorB: Color) {
    return saturation(colorB) - saturation(colorA);
}
